import React from 'react';
import {Form,Input,Button,Checkbox,message,Spin,Switch,Select,DatePicker,Card,Result,Popconfirm,Popover} from 'antd';
import axios from 'axios';
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined,DeleteOutlined } from '@ant-design/icons';
import * as serverconfig from '../serverconn'
import PhoneInput from 'react-phone-number-input'
import uuid from 'react-uuid'


var CryptoJS = require("crypto-js");

message.config({
  top: 200,
  duration: 2,
  maxCount: 3,
  rtl: true,
});

var token= ''
var sacco= ''
const dateFormat = 'DD/MM/YYYY';

const FormItem=Form.Item;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const { Option } = Select;

class  MemberPortalUserCreationForm extends React.Component {

  state = {
    isactive:false,
    ismanager:false,
    profile_pic:null,  
    datarequested:false,
    saccopackageobj:{},

    username:'',
    email:'',
    password1:'',
    password2:'',


    sur_name:'',
    other_name:'',
    nationality:'',
    date_Of_Birth:'',
    Area_Of_Residence:'',
    gender:'',
    RegisteredPhoneNumber1:'',
    members:[],
    selectedaccountobject:{},
    selectedaccount:'',
    message:'',
    datasubmittedsuccessfully:false,
    activation_mode:'selective_members',
    activationlist:[]



  }


  formRef = React.createRef();

  componentDidMount() {

    if(localStorage.getItem("sacco")){
      sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
   }else{
      sacco= ''
   }
   
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(serverconfig.backendserverurl+`/api/members/?sacco=${sacco}`)
    .then(res => {
        this.setState({
          members:res.data
        })
    })
   

  }

  handleprofile_picChange= (e) => this.setState({ profile_pic: e.target.files[0]});

  render(){

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin  size="large">
                <div className="content" />
              </Spin>  
       </div>
      )

    }else{

      if (this.state.datasubmittedsuccessfully===true){
        return(
            <Card>
            <Result
            status="success"
            title="Request status"
            subTitle={this.state.message}
            extra={[
              <Button  type='primary' onClick={()=>{window.location.reload(false)}}>Finish</Button>,
            ]}
            />

          </Card>
        );

      }else{

        return (

          <div>
            <h3>Create new member portal user account here</h3>
            <Form name="Activation">

            <FormItem label="Activation mode" >
                <Select 
                value={this.state.activation_mode} 
                onChange={(val)=>{this.setState({activation_mode:val})}}
                placeholder="Activation mode" >
                  <Option value='selective_members'>Selective members</Option>
                  <Option value='all_members'>All members</Option>
                </Select>
            </FormItem>


          {
            this.state.activation_mode==="selective_members"?
            <div>
            <FormItem label="Member Account">
              <Select 
              placeholder="Account No | Name" 
              style={{  }} 
              value={this.state.selectedaccount}
              onChange={
                (e) =>{
                  this.setState({ selectedaccount: e});
                  //make query for last transactions
                  axios.get(`${serverconfig.backendserverurl}/api/members/${e}`)
                    .then(res => {  
                        this.setState({selectedaccountobject: res.data})
                  })

                }

              } 
              showSearch
              optionFilterProp="children"
              onFocus={this.onFocus}
              onBlur={this.onBlur}
              onSearch={this.onSearch}
                                    
              >
                {this.state.members.map(
                  (accnt)=>(
                    <Option value={accnt.id}>{accnt.AccountNumber} | {accnt.FullName}</Option>
                  ))}
              </Select>
          </FormItem>
  
          <h3>Username: {this.state.selectedaccountobject.AccountNumber} | Email: {this.state.selectedaccountobject.EmailAddress}</h3>


            <Form.Item>
              <Button type="primary" htmlType='button'
              onClick={()=>{

                if (this.state.selectedaccountobject.AccountNumber==="null" || this.state.selectedaccountobject.AccountNumber==="" || this.state.selectedaccountobject.AccountNumber===null){
                  message.error("Username is empty")
                }else if (this.state.selectedaccountobject.EmailAddress==="null" || this.state.selectedaccountobject.EmailAddress==="" || this.state.selectedaccountobject.EmailAddress===null){
                  message.error("Email is empty")
                }else{

                var intobj={
                  'key':uuid(),
                  'memberid':this.state.selectedaccountobject.id,
                  'member_name':this.state.selectedaccountobject.FullName,
                  'member_account':this.state.selectedaccountobject.AccountNumber,

                  'EmailAddress':this.state.selectedaccountobject.EmailAddress,
                  'RegisteredPhoneNumber1':this.state.selectedaccountobject.RegisteredPhoneNumber1,
                }

                this.setState({activationlist: [...this.state.activationlist,intobj]});
                message.info("item added")

              }

              }}>
                Add to list of activation
              </Button>
            </Form.Item>

            <h5 style={{color:'red'}}>NOTE: Only members with active email addresses will be activated (Passwords received over email)</h5>

            {
                this.state.activationlist.length>0?
                <div >
                  {
                    this.state.activationlist.map((item)=>{
                      return (
                      <p>{item.member_name} | {item.EmailAddress} &nbsp;&nbsp;
                      <Popover content={<p>Click here to delete item</p>} title="Delete">
                      <Popconfirm title="Sure to delete?" onConfirm={() => {
                        this.setState({ activationlist:  [...this.state.activationlist.filter(todo => todo.key
                          !==item.key)]});
                      }}>
                        <DeleteOutlined style={{color:'red'}}/>
                      </Popconfirm>
                      </Popover>
                      
                      </p>)
                    })
                  }

                </div>
                :
                null
              }


            </div>

            :
            <h5 style={{color:'red'}}>NOTE: Only members with active email addresses will be activated (Passwords received over email)</h5>

          }


        <FormItem label="Submit request">
        <Button type="primary" htmlType='button'
              onClick={()=>{

                if (this.state.activationlist.length<=0 && this.state.activation_mode==="selective_members"){
                  message.error("List cant be empty")
                }else{

                  this.setState({datarequested:true})

                  let form_data = new FormData();

                  form_data.append('sacco', sacco);
                  form_data.append('activationlist',JSON.stringify(this.state.activationlist));
                  form_data.append('activation_mode',this.state.activation_mode);

                  //Register the account first
                  axios.post(serverconfig.backendserverurl+'/customqueries/massMemberPortalUserActivation',form_data)
                  .then(res =>{
                    this.setState({datarequested:false})
                    this.setState({message:res.data.message})
                    this.setState({datasubmittedsuccessfully:true})

                  })
                .catch(error => console.log(error)) 
                
              }

              }}>
                Submit request
              </Button>

        </FormItem>
          </Form>

          </div>
        );

     }

    }

  }

}


export default MemberPortalUserCreationForm;

